// extracted by mini-css-extract-plugin
export default {"modal":"PostModal_modal__kWvjX","overlay":"PostModal_overlay__8mbX9","form":"PostModal_form__N-VDI","input__large":"PostModal_input__large__TgIy7","button":"PostModal_button__Bo4ds"};